'use strict';

var TDChartPOSAggregationFactory = function TDChartPOSAggregationFactory(DataAggregationFactory, ExtractMetricKeysService) {
  function TDChartPOSAggregation() {
    DataAggregationFactory.call(this, ['market-product-group', 'market', 'service'], ['thematic-demand-chart-market-pos', 'thematic-demand-chart-service-pos']);
  }
  TDChartPOSAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  TDChartPOSAggregation.prototype.canAggregate = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType.indexOf(targetType) !== -1;
  };
  TDChartPOSAggregation.constructor = TDChartPOSAggregation;
  TDChartPOSAggregation.prototype.aggregate = function (data, metrics) {
    var aggregationFunction = this.getAggregationFunction(metrics);
    var aggregatedPOS = {};
    var reducedEntry, metricKeys, keysLength, keys;
    for (var index = 0, dataLength = data.length; index < dataLength; index++) {
      if (Array.isArray(aggregatedPOS[data[index].posName])) {
        aggregatedPOS[data[index].posName].push(data[index]);
      } else {
        aggregatedPOS[data[index].posName] = [data[index]];
      }
    }
    if (Object.keys(aggregatedPOS).length > 0) {
      metricKeys = ExtractMetricKeysService.extract(aggregatedPOS[Object.keys(aggregatedPOS)[0]][0]);
    }
    keys = Object.keys(aggregatedPOS);
    for (index = 0, keysLength = keys.length; index < keysLength; index++) {
      reducedEntry = {};
      reducedEntry.label = keys[index];
      aggregationFunction(aggregatedPOS[keys[index]], metricKeys, reducedEntry);
      aggregatedPOS[keys[index]] = reducedEntry;
    }
    return this.sortAggregationResults(aggregatedPOS);
  };
  return TDChartPOSAggregation;
};
TDChartPOSAggregationFactory.$inject = ['DataAggregationFactory', 'ExtractMetricKeysService'];
module.exports = TDChartPOSAggregationFactory;